
// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 500);

//     this.fastOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 50);

//     const facetForm = this.querySelector('form');
//     if (facetForm) {
//       facetForm.addEventListener('input', (event) => {
//         if (event.target.type === 'checkbox' || event.target.type === 'radio') {
//           this.fastOnSubmit(event);
//         } else {
//           this.debouncedOnSubmit(event);
//         }
//       });
//       facetForm.addEventListener('change', (event) => {
//         if (event.target.type === 'checkbox' || event.target.type === 'radio') {
//           this.fastOnSubmit(event);
//         }
//       });
//     }

//     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
//     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
//   }

//   connectedCallback() {
//     FacetFiltersForm.initMasterFacets();
//   }

//   static hasActiveFilters(searchParams) {
//     if (!searchParams) return false;
//     const params = new URLSearchParams(searchParams);
//     for (const [key, value] of params.entries()) {
//       if (key.startsWith('filter.') && value.trim() !== '') {
//         return true;
//       }
//     }
//     return false;
//   }

//   static getTargetPathname(searchParams) {
//     if (FacetFiltersForm.hasActiveFilters(searchParams)) {
//       return '/collections/all';
//     }
//     return FacetFiltersForm.initialCollectionPathname || window.location.pathname;
//   }

//   static initInitialCollection() {
//     if (!FacetFiltersForm.initialCollectionPathname) {
//       const path = window.location.pathname;
//       if (path !== '/collections/all' && path.startsWith('/collections/')) {
//         FacetFiltersForm.initialCollectionPathname = path;
//         try { sessionStorage.setItem('initialCollectionPathname', path); } catch (e) {}
//       } else {
//         let stored = null;
//         try { stored = sessionStorage.getItem('initialCollectionPathname'); } catch (e) {}
//         FacetFiltersForm.initialCollectionPathname = (window.location.search && stored) ? stored : '/collections/all';
//       }
//     }
//   }

//   static initMasterFacets() {
//     FacetFiltersForm.initInitialCollection();

//     const isAll = window.location.pathname === '/collections/all';
//     const hasFilters = FacetFiltersForm.hasActiveFilters(window.location.search);

//     if (isAll && !hasFilters) {
//       const desktop = document.getElementById('FacetsWrapperDesktop');
//       const mobile = document.getElementById('FacetFiltersFormMobile');
//       if (desktop && desktop.innerHTML.trim().length > 100) {
//         FacetFiltersForm.masterDesktopHTML = desktop.innerHTML;
//         try { sessionStorage.setItem('master_facets_desktop', desktop.innerHTML); } catch (e) {}
//       }
//       if (mobile && mobile.innerHTML.trim().length > 100) {
//         FacetFiltersForm.masterMobileHTML = mobile.innerHTML;
//         try { sessionStorage.setItem('master_facets_mobile', mobile.innerHTML); } catch (e) {}
//       }
//     } else if (!isAll) {
//       let cachedDesktop = null;
//       let cachedMobile = null;
//       try {
//         cachedDesktop = sessionStorage.getItem('master_facets_desktop');
//         cachedMobile = sessionStorage.getItem('master_facets_mobile');
//       } catch (e) {}

//       if (cachedDesktop && cachedMobile) {
//         FacetFiltersForm.applyMasterFacets(cachedDesktop, cachedMobile);
//       } else {
//         FacetFiltersForm.fetchMasterFacets();
//       }
//     }

//     FacetFiltersForm.ensureAllOptionsClickable();
//     FacetFiltersForm.syncCheckboxStates(window.location.search.slice(1));
//   }

//   static fetchMasterFacets() {
//     const sectionElement = document.getElementById('product-grid');
//     const sectionId = sectionElement ? sectionElement.dataset.id : null;
//     if (!sectionId) return;

//     fetch(`/collections/all?section_id=${sectionId}`)
//       .then((res) => res.text())
//       .then((html) => {
//         const parsed = new DOMParser().parseFromString(html, 'text/html');
//         const desktop = parsed.getElementById('FacetsWrapperDesktop');
//         const mobile = parsed.getElementById('FacetFiltersFormMobile');
//         if (desktop && mobile) {
//           const dHtml = desktop.innerHTML;
//           const mHtml = mobile.innerHTML;
//           try {
//             sessionStorage.setItem('master_facets_desktop', dHtml);
//             sessionStorage.setItem('master_facets_mobile', mHtml);
//           } catch (e) {}
//           FacetFiltersForm.applyMasterFacets(dHtml, mHtml);
//         }
//       })
//       .catch((err) => console.error('Error fetching master facets:', err));
//   }

//   static applyMasterFacets(desktopHTML, mobileHTML) {
//     const desktop = document.getElementById('FacetsWrapperDesktop');
//     if (desktop && desktopHTML) {
//       desktop.innerHTML = desktopHTML;
//     }
//     const mobile = document.getElementById('FacetFiltersFormMobile');
//     if (mobile && mobileHTML) {
//       mobile.innerHTML = mobileHTML;
//       mobile.closest('menu-drawer')?.bindEvents?.();
//     }
//     FacetFiltersForm.ensureAllOptionsClickable();
//     FacetFiltersForm.syncCheckboxStates(window.location.search.slice(1));
//   }

//   static ensureAllOptionsClickable() {
//     document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach((form) => {
//       form.querySelectorAll('.facets__label.disabled, .mobile-facets__label.disabled').forEach((label) => {
//         label.classList.remove('disabled');
//       });
//       form.querySelectorAll('input[type="checkbox"][disabled]').forEach((input) => {
//         input.removeAttribute('disabled');
//       });
//     });
//   }

//   static syncCheckboxStates(searchParams) {
//     const params = new URLSearchParams(searchParams || '');
//     const forms = document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile');
//     forms.forEach((form) => {
//       const checkboxes = form.querySelectorAll('input[type="checkbox"]');
//       checkboxes.forEach((cb) => {
//         const name = cb.getAttribute('name');
//         const value = cb.getAttribute('value');
//         if (!name || !value) return;
//         const isChecked = params.getAll(name).includes(value);
//         cb.checked = isChecked;
//         const label = cb.closest('.facets__label, .mobile-facets__label');
//         if (label) {
//           label.classList.toggle('active', isChecked);
//           label.classList.remove('disabled');
//         }
//         cb.removeAttribute('disabled');
//       });

//       form.querySelectorAll('.js-filter').forEach((details) => {
//         const checkedCount = details.querySelectorAll('input[type="checkbox"]:checked').length;
//         const countSpan = details.querySelector('.facets__selected');
//         if (countSpan) {
//           countSpan.textContent = `(${checkedCount})`;
//           countSpan.classList.toggle('hidden', checkedCount === 0);
//         }
//       });
//     });
//   }

//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state ? event.state.searchParams : window.location.search.slice(1);
//       const pathname = event.state && event.state.pathname ? event.state.pathname : window.location.pathname;
//       if (searchParams === FacetFiltersForm.searchParamsPrev && pathname === window.location.pathname) return;
//       FacetFiltersForm.renderPage(searchParams, null, false, pathname);
//     };
//     window.addEventListener('popstate', onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll('.js-facet-remove').forEach((element) => {
//       element.classList.toggle('disabled', disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true, forcedPathname = null) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const updateEvent = FacetFiltersForm.startUpdateEvent(searchParams);
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     const loadingSpinners = document.querySelectorAll(
//       '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
//     const prodGrid = document.getElementById('ProductGridContainer');
//     if (prodGrid) {
//       const collectionEl = prodGrid.querySelector('.collection');
//       if (collectionEl) collectionEl.classList.add('loading');
//     }
//     if (countContainer) {
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop) {
//       countContainerDesktop.classList.add('loading');
//     }

//     const targetPathname = forcedPathname || FacetFiltersForm.getTargetPathname(searchParams);

//     sections.forEach((section) => {
//       const url = `${targetPathname}?section_id=${section.section}&${searchParams}`;
//       const filterDataUrl = (element) => element.url === url;

//       FacetFiltersForm.filterData.some(filterDataUrl)
//         ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent)
//         : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
//     });

//     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, targetPathname);
//   }

//   static startUpdateEvent(searchParams) {
//     const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
//     if (!SearchUpdateEvent && !CollectionUpdateEvent) return;

//     const facetsForm = document.querySelector('facet-filters-form');
//     const facetsContainer = document.querySelector('.facets-container');
//     const collectionId = facetsContainer?.dataset.collectionId || null;
//     const collectionHandle = facetsContainer?.dataset.collectionHandle || '';
//     const currentCount = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
//     const urlSearchParams = new URLSearchParams(searchParams);
//     const isSearchPage = facetsContainer?.dataset.template === 'search';
//     const isCollectionPage = facetsContainer?.dataset.template === 'collection';
//     const dispatchTarget = facetsForm || document;

//     let deferred;

//     if (isSearchPage) {
//       deferred = SearchUpdateEvent.createPromise();
//       dispatchTarget.dispatchEvent(
//         new SearchUpdateEvent({
//           search: {
//             query: urlSearchParams.get('q') || '',
//             productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams),
//             sortKey: SearchUpdateEvent.getSortKey(urlSearchParams),
//           },
//           promise: deferred.promise,
//         }),
//       );
//     } else if (isCollectionPage) {
//       deferred = CollectionUpdateEvent.createPromise();
//       dispatchTarget.dispatchEvent(
//         new CollectionUpdateEvent({
//           collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount },
//           productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams),
//           sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams),
//           promise: deferred.promise,
//         }),
//       );
//     }

//     if (!deferred) return;

//     return {
//       resolve: (filteredCount) => {
//         deferred.resolve({ [isSearchPage ? 'totalCount' : 'productsCount']: filteredCount });
//       },
//       reject: deferred.reject,
//     };
//   }

//   static renderSectionFromFetch(url, event, updateEvent) {
//     fetch(url)
//       .then((response) => response.text())
//       .then((html) => {
//         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
//         FacetFiltersForm.renderSection(html, event, updateEvent);
//       })
//       .catch((error) => {
//         console.error(error);
//         updateEvent?.reject(error);
//       });
//   }

//   static renderSectionFromCache(filterDataUrl, event, updateEvent) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderSection(html, event, updateEvent);
//   }

//   static renderSection(html, event, updateEvent) {
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html, updateEvent);
//     if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
//   }

//   static renderProductGridContainer(html) {
//     document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
//       .parseFromString(html, 'text/html')
//       .getElementById('ProductGridContainer').innerHTML;

//     document
//       .getElementById('ProductGridContainer')
//       .querySelectorAll('.scroll-trigger')
//       .forEach((element) => {
//         element.classList.add('scroll-trigger--cancel');
//       });
//   }

//   static renderProductCount(html, updateEvent) {
//     const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
//     const sourceCount = parsedHtml.getElementById('ProductCount');
//     if (!sourceCount) return;
//     const count = sourceCount.innerHTML;
//     const container = document.getElementById('ProductCount');
//     const containerDesktop = document.getElementById('ProductCountDesktop');
//     if (container) {
//       container.innerHTML = count;
//       container.dataset.productCount = sourceCount.dataset.productCount || '';
//       container.dataset.totalCount = sourceCount.dataset.totalCount || '';
//       container.classList.remove('loading');
//     }
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
//     const loadingSpinners = document.querySelectorAll(
//       '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

//     updateEvent?.resolve(parseInt(sourceCount.dataset.productCount) || 0);
//   }

//   static renderFilters(html, event) {
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

//     // 1. Render active facets pills (desktop & mobile)
//     FacetFiltersForm.renderActiveFacets(parsedHTML);

//     // 2. Render mobile count & sorting elements
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     // 3. Update PriceRange if present
//     parsedHTML.querySelectorAll('price-range').forEach((newPriceRange) => {
//       const oldPriceRange = document.getElementById(newPriceRange.id);
//       if (oldPriceRange) {
//         oldPriceRange.outerHTML = newPriceRange.outerHTML;
//       }
//     });

//     // 4. Synchronize all checkboxes with active searchParams
//     FacetFiltersForm.syncCheckboxStates(FacetFiltersForm.searchParamsPrev);

//     // 5. Ensure all series and category options remain enabled and interactive
//     FacetFiltersForm.ensureAllOptionsClickable();
//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       const currentElement = document.querySelector(selector);
//       if (currentElement) {
//         currentElement.innerHTML = activeFacetsElement.innerHTML;
//       }
//     });

//     FacetFiltersForm.toggleActiveFacets(false);
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

//     mobileElementSelectors.forEach((selector) => {
//       const sourceEl = html.querySelector(selector);
//       if (!sourceEl) return;
//       const targetEl = document.querySelector(selector);
//       if (targetEl) {
//         targetEl.innerHTML = sourceEl.innerHTML;
//       }
//     });

//     const mobileDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
//     if (mobileDrawer && typeof mobileDrawer.bindEvents === 'function') {
//       mobileDrawer.bindEvents();
//     }
//   }

//   static renderCounts(source, target) {
//     const targetSummary = target.querySelector('.facets__summary');
//     const sourceSummary = source.querySelector('.facets__summary');

//     if (sourceSummary && targetSummary) {
//       targetSummary.outerHTML = sourceSummary.outerHTML;
//     }

//     const targetHeaderElement = target.querySelector('.facets__header');
//     const sourceHeaderElement = source.querySelector('.facets__header');

//     if (sourceHeaderElement && targetHeaderElement) {
//       targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
//     }
//   }

//   static renderMobileCounts(source, target) {
//     const targetFacetsList = target.querySelector('.mobile-facets__list');
//     const sourceFacetsList = source.querySelector('.mobile-facets__list');

//     if (sourceFacetsList && targetFacetsList) {
//       targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
//     }
//   }

//   static updateURLHash(searchParams, targetPathname) {
//     const pathname = targetPathname || FacetFiltersForm.getTargetPathname(searchParams);
//     const newUrl = `${pathname}${searchParams ? '?' + searchParams : ''}`;
//     history.pushState({ searchParams, pathname }, '', newUrl);
//   }

//   static getSections() {
//     return [
//       {
//         section: document.getElementById('product-grid').dataset.id,
//       },
//     ];
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//   }

//   onSubmitHandler(event) {
//     if (event) event.preventDefault();
//     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
//     const isMobile = event && event.target && event.target.closest('form')
//       ? event.target.closest('form').id === 'FacetFiltersFormMobile'
//       : false;

//     const forms = [];
//     sortFilterForms.forEach((form) => {
//       if (!isMobile) {
//         if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
//           forms.push(this.createSearchParams(form));
//         }
//       } else if (form.id === 'FacetFiltersFormMobile') {
//         forms.push(this.createSearchParams(form));
//       }
//     });
//     const searchParams = forms.filter(Boolean).join('&');
//     this.onSubmitForm(searchParams, event);
//   }

//   onActiveFilterClick(event) {
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url =
//       event.currentTarget.href.indexOf('?') == -1
//         ? ''
//         : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
//     FacetFiltersForm.renderPage(url);
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// FacetFiltersForm.initialCollectionPathname = null;
// FacetFiltersForm.masterDesktopHTML = null;
// FacetFiltersForm.masterMobileHTML = null;

// if (!customElements.get('facet-filters-form')) {
//   customElements.define('facet-filters-form', FacetFiltersForm);
// }
// FacetFiltersForm.setListeners();

// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.initMasterFacets());
// } else {
//   FacetFiltersForm.initMasterFacets();
// }

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   onKeyDown(event) {
//     if (event.metaKey) return;

//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

// customElements.define('price-range', PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);


































class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.fastOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 50);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        if (event.target.type === 'checkbox' || event.target.type === 'radio') {
          this.fastOnSubmit(event);
        } else {
          this.debouncedOnSubmit(event);
        }
      });
      facetForm.addEventListener('change', (event) => {
        if (event.target.type === 'checkbox' || event.target.type === 'radio') {
          this.fastOnSubmit(event);
        }
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  connectedCallback() {
    FacetFiltersForm.initMasterFacets();
  }

  static isSearchPage() {
    return window.location.pathname.startsWith('/search') || document.querySelector('.facets-container')?.dataset.template === 'search';
  }

  static hasActiveFilters(searchParams) {
    if (!searchParams) return false;
    const params = new URLSearchParams(searchParams);
    for (const [key, value] of params.entries()) {
      if (key.startsWith('filter.') && value.trim() !== '') {
        return true;
      }
    }
    return false;
  }

  static getTargetPathname(searchParams) {
    if (FacetFiltersForm.isSearchPage()) {
      return window.location.pathname;
    }
    if (FacetFiltersForm.hasActiveFilters(searchParams)) {
      return '/collections/all';
    }
    return FacetFiltersForm.initialCollectionPathname || window.location.pathname;
  }

  static initInitialCollection() {
    if (FacetFiltersForm.isSearchPage()) return;
    if (!FacetFiltersForm.initialCollectionPathname) {
      const path = window.location.pathname;
      if (path !== '/collections/all' && path.startsWith('/collections/')) {
        FacetFiltersForm.initialCollectionPathname = path;
        try { sessionStorage.setItem('initialCollectionPathname', path); } catch (e) {}
      } else {
        let stored = null;
        try { stored = sessionStorage.getItem('initialCollectionPathname'); } catch (e) {}
        FacetFiltersForm.initialCollectionPathname = (window.location.search && stored) ? stored : '/collections/all';
      }
    }
  }

  static initMasterFacets() {
    if (FacetFiltersForm.isSearchPage()) {
      FacetFiltersForm.ensureAllOptionsClickable();
      FacetFiltersForm.syncCheckboxStates(window.location.search.slice(1));
      return;
    }

    FacetFiltersForm.initInitialCollection();

    const isAll = window.location.pathname === '/collections/all';
    const hasFilters = FacetFiltersForm.hasActiveFilters(window.location.search);

    if (isAll && !hasFilters) {
      const desktop = document.getElementById('FacetsWrapperDesktop');
      const mobile = document.getElementById('FacetFiltersFormMobile');
      if (desktop && desktop.innerHTML.trim().length > 100) {
        FacetFiltersForm.masterDesktopHTML = desktop.innerHTML;
        try { sessionStorage.setItem('master_facets_desktop', desktop.innerHTML); } catch (e) {}
      }
      if (mobile && mobile.innerHTML.trim().length > 100) {
        FacetFiltersForm.masterMobileHTML = mobile.innerHTML;
        try { sessionStorage.setItem('master_facets_mobile', mobile.innerHTML); } catch (e) {}
      }
    } else if (!isAll) {
      let cachedDesktop = null;
      let cachedMobile = null;
      try {
        cachedDesktop = sessionStorage.getItem('master_facets_desktop');
        cachedMobile = sessionStorage.getItem('master_facets_mobile');
      } catch (e) {}

      if (cachedDesktop && cachedMobile) {
        FacetFiltersForm.applyMasterFacets(cachedDesktop, cachedMobile);
      } else {
        FacetFiltersForm.fetchMasterFacets();
      }
    }

    FacetFiltersForm.ensureAllOptionsClickable();
    FacetFiltersForm.syncCheckboxStates(window.location.search.slice(1));
  }

  static fetchMasterFacets() {
    const sectionElement = document.getElementById('product-grid');
    const sectionId = sectionElement ? sectionElement.dataset.id : null;
    if (!sectionId) return;

    fetch(`/collections/all?section_id=${sectionId}`)
      .then((res) => res.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const desktop = parsed.getElementById('FacetsWrapperDesktop');
        const mobile = parsed.getElementById('FacetFiltersFormMobile');
        if (desktop && mobile) {
          const dHtml = desktop.innerHTML;
          const mHtml = mobile.innerHTML;
          try {
            sessionStorage.setItem('master_facets_desktop', dHtml);
            sessionStorage.setItem('master_facets_mobile', mHtml);
          } catch (e) {}
          FacetFiltersForm.applyMasterFacets(dHtml, mHtml);
        }
      })
      .catch((err) => console.error('Error fetching master facets:', err));
  }

  static applyMasterFacets(desktopHTML, mobileHTML) {
    const desktop = document.getElementById('FacetsWrapperDesktop');
    if (desktop && desktopHTML) {
      desktop.innerHTML = desktopHTML;
    }
    const mobile = document.getElementById('FacetFiltersFormMobile');
    if (mobile && mobileHTML) {
      mobile.innerHTML = mobileHTML;
      mobile.closest('menu-drawer')?.bindEvents?.();
    }
    FacetFiltersForm.ensureAllOptionsClickable();
    FacetFiltersForm.syncCheckboxStates(window.location.search.slice(1));
  }

  static ensureAllOptionsClickable() {
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach((form) => {
      form.querySelectorAll('.facets__label.disabled, .mobile-facets__label.disabled').forEach((label) => {
        label.classList.remove('disabled');
      });
      form.querySelectorAll('input[type="checkbox"][disabled]').forEach((input) => {
        input.removeAttribute('disabled');
      });
    });
  }

  static syncCheckboxStates(searchParams) {
    const params = new URLSearchParams(searchParams || '');
    const forms = document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile');
    forms.forEach((form) => {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((cb) => {
        const name = cb.getAttribute('name');
        const value = cb.getAttribute('value');
        if (!name || !value) return;
        const isChecked = params.getAll(name).includes(value);
        cb.checked = isChecked;
        const label = cb.closest('.facets__label, .mobile-facets__label');
        if (label) {
          label.classList.toggle('active', isChecked);
          label.classList.remove('disabled');
        }
        cb.removeAttribute('disabled');
      });

      form.querySelectorAll('.js-filter').forEach((details) => {
        const checkedCount = details.querySelectorAll('input[type="checkbox"]:checked').length;
        const countSpan = details.querySelector('.facets__selected');
        if (countSpan) {
          countSpan.textContent = `(${checkedCount})`;
          countSpan.classList.toggle('hidden', checkedCount === 0);
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : window.location.search.slice(1);
      const pathname = event.state && event.state.pathname ? event.state.pathname : window.location.pathname;
      if (searchParams === FacetFiltersForm.searchParamsPrev && pathname === window.location.pathname) return;
      FacetFiltersForm.renderPage(searchParams, null, false, pathname);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, forcedPathname = null) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const updateEvent = FacetFiltersForm.startUpdateEvent(searchParams);
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const prodGrid = document.getElementById('ProductGridContainer');
    if (prodGrid) {
      const collectionEl = prodGrid.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    const targetPathname = forcedPathname || FacetFiltersForm.getTargetPathname(searchParams);

    sections.forEach((section) => {
      const url = `${targetPathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent)
        : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, targetPathname);
  }

  static startUpdateEvent(searchParams) {
    const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent && !CollectionUpdateEvent) return;

    const facetsForm = document.querySelector('facet-filters-form');
    const facetsContainer = document.querySelector('.facets-container');
    const collectionId = facetsContainer?.dataset.collectionId || null;
    const collectionHandle = facetsContainer?.dataset.collectionHandle || '';
    const currentCount = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
    const urlSearchParams = new URLSearchParams(searchParams);
    const isSearchPage = facetsContainer?.dataset.template === 'search';
    const isCollectionPage = facetsContainer?.dataset.template === 'collection';
    const dispatchTarget = facetsForm || document;

    let deferred;

    if (isSearchPage) {
      deferred = SearchUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new SearchUpdateEvent({
          search: {
            query: urlSearchParams.get('q') || '',
            productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams),
            sortKey: SearchUpdateEvent.getSortKey(urlSearchParams),
          },
          promise: deferred.promise,
        }),
      );
    } else if (isCollectionPage) {
      deferred = CollectionUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new CollectionUpdateEvent({
          collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount },
          productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams),
          sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams),
          promise: deferred.promise,
        }),
      );
    }

    if (!deferred) return;

    return {
      resolve: (filteredCount) => {
        deferred.resolve({ [isSearchPage ? 'totalCount' : 'productsCount']: filteredCount });
      },
      reject: deferred.reject,
    };
  }

  static renderSectionFromFetch(url, event, updateEvent) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderSection(html, event, updateEvent);
      })
      .catch((error) => {
        console.error(error);
        updateEvent?.reject(error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, updateEvent) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event, updateEvent);
  }

  static renderSection(html, event, updateEvent) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html, updateEvent);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html, updateEvent) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHtml.getElementById('ProductCount') || parsedHtml.getElementById('ProductCountDesktop');
    if (!sourceCount) return;
    const count = sourceCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.dataset.productCount = sourceCount.dataset.productCount || '';
      container.dataset.totalCount = sourceCount.dataset.totalCount || '';
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    updateEvent?.resolve(parseInt(sourceCount.dataset.productCount) || 0);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // 1. Render active facets pills (desktop & mobile)
    FacetFiltersForm.renderActiveFacets(parsedHTML);

    // 2. Render mobile count & sorting elements
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // 3. Update PriceRange if present
    parsedHTML.querySelectorAll('price-range').forEach((newPriceRange) => {
      const oldPriceRange = document.getElementById(newPriceRange.id);
      if (oldPriceRange) {
        oldPriceRange.outerHTML = newPriceRange.outerHTML;
      }
    });

    // 4. Synchronize all checkboxes with active searchParams
    FacetFiltersForm.syncCheckboxStates(FacetFiltersForm.searchParamsPrev);

    // 5. Ensure all series and category options remain enabled and interactive
    FacetFiltersForm.ensureAllOptionsClickable();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const currentElement = document.querySelector(selector);
      if (currentElement) {
        currentElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      if (!sourceEl) return;
      const targetEl = document.querySelector(selector);
      if (targetEl) {
        targetEl.innerHTML = sourceEl.innerHTML;
      }
    });

    const mobileDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (mobileDrawer && typeof mobileDrawer.bindEvents === 'function') {
      mobileDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams, targetPathname) {
    const pathname = targetPathname || FacetFiltersForm.getTargetPathname(searchParams);
    const newUrl = `${pathname}${searchParams ? '?' + searchParams : ''}`;
    history.pushState({ searchParams, pathname }, '', newUrl);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const isMobile = event && event.target && event.target.closest('form')
      ? event.target.closest('form').id === 'FacetFiltersFormMobile'
      : false;

    const forms = [];
    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    const searchParams = forms.filter(Boolean).join('&');
    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.initialCollectionPathname = null;
FacetFiltersForm.masterDesktopHTML = null;
FacetFiltersForm.masterMobileHTML = null;

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}
FacetFiltersForm.setListeners();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.initMasterFacets());
} else {
  FacetFiltersForm.initMasterFacets();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);